/**
 * Theme System
 * Unified export for all theme utilities and constants
 */

// Colors
export { ColorType, ColorValue, getColorValue, getAccentColor, getBlackColor } from './colors';

// Typography
export { FontFamily, FontFamilyValue, FontWeight, BASE_FONT_SIZE, getFontFamily } from './typography';

// Spacing
export { pxToRem, type SpacingKey } from './spacing';

// Radius
export { RadiusSize, RadiusValue, getRadiusValue, getRadiusCssValue } from './radius';

// Breakpoints
export { Viewport, mediaQueries } from './breakpoints';

// Gradients
export { 
  GradientType, 
  gradients, 
  getGradient, 
  getBackgroundGradient,
  buildGradientString,
  GradientPreset,
  gradientPresets,
  getGradientPreset,
  getGradientPresetString,
  type BorderGradient,
  type GradientColorStop,
} from './gradients';

// Z-Index
export { zIndex, type ZIndex } from './zIndex';

// Presets
export { createPresetRegistry, type BasePresetConfig, type PresetRegistry } from './presets';

// Types
export type {
  ThemeColors,
  ThemeTypography,
  ThemeSpacing,
  ThemeBreakpoint,
  ThemeGradient,
  PresetConfig,
} from './theme.types';
